import { useQuery } from '@tanstack/react-query';

import {
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
} from 'lib_api/lib/api/gen';

import {
  ControllerApi,
  displayWarning,
  fetchArPndNotificationResult,
  isInstanceOfAdminFonctionnel,
  SetDossierAdminF,
  SetDossierFo,
} from './utils';

export function useFetchArPndNotification(
  controller: ControllerApi,
  dossierId: string,
  setDossier: SetDossierAdminF | SetDossierFo,
): fetchArPndNotificationResult {
  const { refetch: refetchArPnd } = useQuery({
    queryKey: ['fetchArPnd', dossierId],
    queryFn: () => getFetchArPndNotification(controller)(dossierId),
    enabled: false,
    retry: 0,
  });

  const fetchArPndNotification = async () => {
    const result = await refetchArPnd();
    if (result.isSuccess) {
      setDossier(
        result.data as DossierDtoAdminFonctionnel & DossierResponseDto,
      );
    } else if (result.isError) {
      displayWarning();
    }
  };

  return { fetchArPndNotification };
}

function getFetchArPndNotification(
  controller: ControllerApi,
): (id: string) => Promise<DossierDtoAdminFonctionnel | DossierResponseDto> {
  if (isInstanceOfAdminFonctionnel(controller)) {
    return controller.fetchArPndUsingPOST1.bind(controller);
  }
  return controller.fetchArPndUsingPOST.bind(controller);
}
